export enum DamageType {
	BUBBLE,
	BLAST,
	EXPLOSION,
	FIRE,
	TOXIC_GAS,
	ELECTRIC,
	MELEE,
	ICE,
}
